import { Truck, Clock, Users } from "lucide-react";

export default function ServiceFeatures() {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-br from-blue-200/20 to-indigo-200/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
            Why Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Experience exceptional service with every order through our commitment to quality,
            freshness, and customer satisfaction.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center group">
            <div className="flex justify-center mb-8">
              <div className="p-8 bg-white rounded-2xl border border-blue-200 group-hover:border-blue-300 transition-all duration-300 shadow-lg hover:shadow-xl">
                <Truck className="h-12 w-12 text-blue-600" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors">Fast Delivery</h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              Quick and reliable delivery ensures your fresh salads arrive
              at the perfect time for your meal.
            </p>
          </div>

          <div className="text-center group">
            <div className="flex justify-center mb-8">
              <div className="p-8 bg-white rounded-2xl border border-indigo-200 group-hover:border-indigo-300 transition-all duration-300 shadow-lg hover:shadow-xl">
                <Clock className="h-12 w-12 text-indigo-600" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-indigo-600 transition-colors">Order Tracking</h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              Track your order in real-time from preparation to delivery
              with our easy-to-use tracking system.
            </p>
          </div>

          <div className="text-center group">
            <div className="flex justify-center mb-8">
              <div className="p-8 bg-white rounded-2xl border border-purple-200 group-hover:border-purple-300 transition-all duration-300 shadow-lg hover:shadow-xl">
                <Users className="h-12 w-12 text-purple-600" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-purple-600 transition-colors">Group Orders</h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              Perfect for office lunches and events with special pricing
              and coordination for large orders.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
